// extracted by mini-css-extract-plugin
export var activityLogTabs = "activity-log__tabs_fz_h1VKPmNKlfZ92qind";